import { Typography } from '@mui/material';
import { ImportProspectsStepViewContainer } from '../containers';
import { ReviewContainer } from './containers';
import { ImportedProspectsOverview } from './elements';
import { useAppSelector } from '../../../../redux/store/configureStore';
import {
    BulkImportProspectDataDto,
    BulkImportValidationResponseDto,
    ImportProspectSkippedIssue,
} from '@zaplify/prospects';
import ProspectsTable from './prospects-table';
import { useDispatch } from 'react-redux-latest';
import { updateWholeImportProspectsState } from '../../../../redux/actions';
import { useState } from 'react';

export const ImportProspectSkippedIssueMapping: { [K in keyof typeof ImportProspectSkippedIssue]: string } = {
    [ImportProspectSkippedIssue.BLOCKLISTED]: 'Blocklisted',
    [ImportProspectSkippedIssue.DUPLICATE]: 'Duplicate in file',
    [ImportProspectSkippedIssue.EXISTS_IN_CRM]: 'Exists in CRM',
    [ImportProspectSkippedIssue.EXISTS_IN_ORGANIZATION]: 'Exists in organization',
};

export const ReviewImportedProspects = (props) => {
    const reviewDetails = useAppSelector(
        (state) => state.importProspects?.reviewDetails || {}
    ) as BulkImportValidationResponseDto & { selectedProspects: BulkImportProspectDataDto[] };
    const dispatch = useDispatch();
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const onAlternativeProspectSelect = (rowNumber: number, alternative: number) => {
        const selectedProspects = reviewDetails.selectedProspects.map((prevSelectedProspect) => {
            if (prevSelectedProspect.rowNumber === rowNumber) {
                if (alternative === -1)
                    return reviewDetails.validProspects.find((prospect) => prospect.rowNumber === rowNumber);

                return reviewDetails.prospectAlternatives.filter((prospect) => prospect.rowNumber === rowNumber)[
                    alternative
                ];
            }
            return prevSelectedProspect;
        });

        dispatch(updateWholeImportProspectsState({ reviewDetails: { ...reviewDetails, selectedProspects } }));
    };

    const handleRemoveUnmatchedProspects = () => {
        const prospectsWithAlternatives = reviewDetails.prospectAlternatives.map((prospect) => prospect.rowNumber);
        const prospectsWithMatches = reviewDetails.selectedProspects.filter((prospect) =>
            prospectsWithAlternatives.includes(prospect.rowNumber)
        );
        console.log('prospectsWithMatches', prospectsWithMatches);
        // Remove all prospects that have no matches
        dispatch(
            updateWholeImportProspectsState({
                reviewDetails: { ...reviewDetails, selectedProspects: prospectsWithMatches },
            })
        );
    };

    const skippedProspectsWithIssues = reviewDetails.skippedProspects?.map((skippedProspect) => {
        const { issues, prospectData } = skippedProspect;
        const mappedIssues = issues ? issues.map((issue) => ImportProspectSkippedIssueMapping[issue]).join(', ') : '';
        return { issues: mappedIssues, ...prospectData };
    });

    return (
        <ImportProspectsStepViewContainer
            style={{
                justifyContent: 'flex-start',
            }}
        >
            <ReviewContainer>
                <Typography variant="h4" className="review-imported-heading">
                    Review
                </Typography>
                <Typography className="review-imported-subline">
                    Success! We found{' '}
                    {Array.isArray(reviewDetails.validProspects) && reviewDetails.validProspects.length} new prospects
                    to add from your CSV.
                    {reviewDetails.prospectAlternatives?.length > 0 &&
                        ' Some prospects matched people in the database, select the correct one for richer data.'}
                </Typography>
                <ImportedProspectsOverview
                    validProspects={reviewDetails.validProspects}
                    errorProspects={reviewDetails.errorProspects}
                    skippedProspects={skippedProspectsWithIssues}
                />
            </ReviewContainer>
            {reviewDetails.validProspects?.length && (
                <ProspectsTable
                    selectedProspects={reviewDetails.selectedProspects}
                    alternatives={reviewDetails.prospectAlternatives}
                    originalProspects={reviewDetails.validProspects}
                    onSelectAlternativeProspect={onAlternativeProspectSelect}
                    onRemoveUnmatchedProspects={handleRemoveUnmatchedProspects}
                    page={page}
                    onPageChange={setPage}
                    perPage={rowsPerPage}
                    onPerPageChange={setRowsPerPage}
                />
            )}
        </ImportProspectsStepViewContainer>
    );
};

ReviewImportedProspects.propTypes = {};
